import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    :root{
        --maxWidth: 1400px;
        --headerHeight: 72px;
        --darkBG: #0a0a0a;
        --lightText: #f4f4f5;
        --accentGold: #d4af37;
        --accentBlue: #3b82f6;
        --cardBG: rgba(255, 255, 255, 0.03);
        --cardBorder: rgba(255, 255, 255, 0.08);
        --fontSuperBig: 3.5rem;
        --fontBig: 2.5rem;
        --fontMed: 1.5rem;
        --fontSmall: 1.1rem;
    }

    @media (max-width: 768px) {
        :root {
            --fontSuperBig: 2.15rem;
            --fontBig: 1.75rem;
            --fontMed: 1.05rem;
            --fontSmall: 0.95rem;
        }
    }

    @media (max-width: 480px) {
        :root {
            --fontSuperBig: 1.85rem;
            --fontBig: 1.5rem;
            --fontMed: 1rem;
            --fontSmall: 0.9rem;
        }
    }

    * {
        color: var(--lightText);
        font-family: 'Outfit', sans-serif;
    }
    
    *, *::before, *::after {
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;
        scroll-padding-top: var(--headerHeight);
        -webkit-text-size-adjust: 100%;
    }

    body{
        margin: 0;
        padding: 0;
        background-color: var(--darkBG);
        background-image: 
            radial-gradient(circle at 15% 50%, rgba(59, 130, 246, 0.04), transparent 25%),
            radial-gradient(circle at 85% 30%, rgba(212, 175, 55, 0.04), transparent 25%);
        background-attachment: fixed;
        min-height: 100vh;
        overflow-x: hidden;

        h1, h2, h3, h4, h5, h6 {
            margin: 0;
            font-weight: 600;
        }

        h1 {
            font-size: var(--fontSuperBig);
            line-height: 1.15;
            background: linear-gradient(to right, #fff, #a1a1aa);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        h2 {
            line-height: 1.2;
        }

        img {
            max-width: 100%;
            height: auto;
        }
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    *[id] {
        scroll-margin-top: var(--headerHeight);
    }

    button {
        font-family: inherit;
    }
`;
